
export default {
  MINIBROWSE_SEARCH_LOADING: 'MINIBROWSE_SEARCH_LOADING',
};


// WEBPACK FOOTER //
// ./modules/browse/constants/MiniBrowseConstants.js